import React from "react";
import Svg, { Path } from "react-native-svg";

const RightIcon = () => {
  return (
    <Svg width="14" height="14" viewBox="0 0 99 102" fill="none">
      <Path
        d="M93.9584 51.1006H0.240967"
        stroke="#0843F5"
        strokeWidth="13"
        strokeMiterlimit="10"
        strokeLinejoin="round"
      />
      <Path
        d="M47.0996 4.23926L93.9583 51.098L47.0996 97.9567"
        stroke="#0843F5"
        strokeWidth="13"
        strokeLinejoin="round"
      />
    </Svg>
  );
};
export default RightIcon;
